/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import Vue from 'vue';
/**
 * @module Store/files
 * @description Module for file handling
 */

/**
 * @constant State of files store
 * @type {object}
 * @description This constant holds the state of files store
 * */
const state = {
    data: []
};

/**
 * @constant Getters
 * @type {object}
 * @description This constant represents the getters for the files store
 * */
const getters = {
};

/**
 * @constant Mutations
 * @type {object}
 * @description This constant represents the mutations for the files store
 * */
const mutations = {
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async getContextNotifications ({state}, context=undefined ) {
        let q = '/collecter/classes/screen';
        if(context){
            q = `/collecter/classes/screen?where={context: ${context}}`;
        }
        const { data: data } = await Vue.axios.get(q, {
            headers: {
                'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'
            }
        });

        state.data = data;
        return {data};
    },
    async setLoggingRegisterCube ({getters}, cube){
        let q = '/collecter/classes/cuberegisterlog';

        const user = await getters.getUser
        let dataToSend = {
            ...cube,
            user,
        }

        const { data: data } = await Vue.axios.post(q, dataToSend, {
            headers: {
                'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'
            }
        });
        console.log({data});

    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
